<template>
    <div class="systemManager">
        <HandMenu/>
        <el-card shadow="never" style="border: 0;border-right: 1px solid #EBEEF5;">
            <el-row :gutter="20">
                <el-breadcrumb separator-class="el-icon-arrow-right" style="padding: 20px">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>当前位置</el-breadcrumb-item>
                </el-breadcrumb>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>轮播图配置</span>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="updateFrontNavigation">
                            提交修改
                        </el-button>
                    </div>
                    <el-row :gutter="20">
                        <el-col :md="8" style="text-align: center;margin-top: 15px;"
                                v-for="navigation in frontNavigationList" :key="navigation.frontNavigationId">
                            <el-image
                                    :src="navigation.frontNavigationImage">
                            </el-image>
                            <el-input placeholder="请输入内容" v-model="navigation.frontNavigationName">
                                <template slot="prepend">导航标题</template>
                            </el-input>
                            <el-input placeholder="请输入内容" v-model="navigation.frontNavigationUrl"
                                      style="margin-top: 10px;">
                                <template slot="prepend">导航地址</template>
                            </el-input>
                        </el-col>
                    </el-row>
                </el-card>

                <el-card class="box-card" style="margin-top: 15px;">
                    <div slot="header" class="clearfix">
                        <span>轮播图配置</span>
                        <el-button style="float: right; padding: 3px 0" type="text" @click="addRotationChart=true">
                            添加轮播图
                        </el-button>
                    </div>
                    <el-row :gutter="20">
                        <el-col :md="8" style="text-align: center;margin-top: 10px;"
                                v-for="rotationChart in rotationChartList" :key="rotationChart.rotationChartId">
                            <el-card class="box-card" style="margin-top: 15px;">
                                <el-image
                                        :src="rotationChart.rotationChartFileUrl"
                                        :preview-src-list="imgList">
                                </el-image>
                                <el-input placeholder="请输入内容" v-model="rotationChart.rotationChartAddr"
                                          style="margin-top: 10px;">
                                    <template slot="prepend">导航地址</template>
                                </el-input>
                                <el-button type="text" @click="updateRotationChart(rotationChart)">修改地址</el-button>
                                <!--删除内容的按钮-->
                                <el-popconfirm
                                        style="margin-left: 10px;"
                                        icon="el-icon-info"
                                        iconColor="red"
                                        title="是否确认删除内容？删除后无法恢复！"
                                        @onConfirm="deleteRotationChart(rotationChart)"
                                >
                                    <el-button slot="reference" type="text" size="small">删除</el-button>
                                </el-popconfirm>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-card>
            </el-row>
        </el-card>
        <!--添加轮播图的对话框-->
        <el-dialog
                title="添加轮播图"
                :visible.sync="addRotationChart"
                width="30%">
            <el-input placeholder="请输入内容" v-model="rotationChartUrl"
                      style="margin-top: 10px;">
                <template slot="prepend">导航地址</template>
            </el-input>
            <CheckImageFile ref="inputFile" :visibleState="true" style="text-align: center"/>
            <span slot="footer" class="dialog-footer">
        <el-button @click="addRotationChart = false">取 消</el-button>
        <el-button type="primary" @click="insertRotationChart">确 定</el-button>
         </span>
        </el-dialog>

    </div>
</template>

<script>
    import axios from "../../api/index"
    import Vue from "../../main";
    import CheckImageFile from "../../components/CheckImageFile";

    export default {
        name: "systemManager",
        components: {
            CheckImageFile
        },
        data() {
            return {
                imgList: [
                    'http://army.xiamijiangvr.com/static/images/banner_0926.png'
                ],
                //导航内容集合
                frontNavigationList: [],
                //轮播图内容集合
                rotationChartList: [],
                //--------------添加轮播图----------
                addRotationChart: false,
                rotationChartUrl: ""
            }
        },
        methods: {
            //初始化前端导航内容
            initFrontNavigation() {
                let self = this;
                axios.getFrontNavigation().then(res => {
                    self.frontNavigationList = res.data.frontNavigationList;
                })
            },
            //提交修改前端导航内容
            updateFrontNavigation() {
                let self = this;
                let list = JSON.stringify(self.frontNavigationList);
                axios.updateFrontNavigation({
                    frontNavigationList: list
                }).then(res => {
                    if (res.data.state) {
                        Vue.$message({
                            message: "更新成功！",
                            duration: 1500,
                            type: "success"
                        });
                    } else {
                        Vue.$message({
                            message: "出现意外错误，请联系开发人员！",
                            duration: 1500,
                            type: "error"
                        });
                    }
                })
            },
            //初始化轮播图数据
            initRotationChart() {
                let self = this;
                axios.getRotationChart().then(res => {
                    self.rotationChartList = res.data.rotationChartList;
                })
            },
            //更新轮播图地址
            updateRotationChart(rotationChart) {
                axios.updateRotationChart({
                    id: rotationChart.rotationChartId,
                    url: rotationChart.rotationChartAddr
                }).then(res => {
                    if (res.data.state === "success") {
                        Vue.$message({
                            message: "地址修改成功！",
                            duration: 1500,
                            type: "success"
                        });
                    } else {
                        Vue.$message({
                            message: "出现意外错误，请联系开发人员！",
                            duration: 1500,
                            type: "error"
                        });
                    }
                })
            },
            //删除轮播图
            deleteRotationChart(rotationChart) {
                let self = this;
                axios.deleteRotationChart({
                    id: rotationChart.rotationChartId,
                    imageName: rotationChart.rotationChartFileName
                }).then(res => {
                    if (res.data.state) {
                        Vue.$message({
                            message: "删除成功！",
                            duration: 1500,
                            type: "success"
                        });
                        self.initRotationChart();
                    } else {
                        Vue.$message({
                            message: "出现意外错误，请联系开发人员！",
                            duration: 1500,
                            type: "error"
                        });
                    }
                })
            },
            //添加新的轮播图
            insertRotationChart() {
                let self = this;
                //获取组件中的文件
                let image = this.$refs.inputFile.returnImageFile();
                if (self.rotationChartUrl == null || self.rotationChartUrl.replace(/\s*/g, "") === "") {
                    Vue.$message({
                        message: "请输入活动标题！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }

                if (image == null) {
                    Vue.$message({
                        message: "请选择要上传的图片！",
                        duration: 1500,
                        type: "error"
                    });
                    return;
                }
                //创建form表单
                let formData = new FormData();
                formData.append("rotationChartUrl", self.rotationChartUrl);
                formData.append("image", image);
                console.log(image)
                //提交form表单
                axios.insertRotationChart(
                    formData
                ).then(res => {
                    if (res.data.state === "success") {
                        Vue.$message({
                            message: "添加轮播图成功！",
                            duration: 1500,
                            type: "success"
                        });
                        self.rotationChartUrl="";
                        self.initRotationChart();
                        self.addRotationChart = false;
                        self.$refs.inputFile.clearImageInput();
                    } else {
                        Vue.$message({
                            message: "出现意外错误，请联系开发人员！",
                            duration: 1500,
                            type: "error"
                        });
                    }
                })
            }
        },
        mounted() {
            this.initFrontNavigation();
            this.initRotationChart();
        }
    }
</script>

<style scoped>
    .systemManager {
        flex: 1;
        overflow: auto;
        width: 100%;
        border: 0;
    }
</style>
